module.exports = __webpack_public_path__ + "assets/img/characters_logo_mobile.950db828.png";